/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faLayerGroup} from '@fortawesome/pro-duotone-svg-icons';

const FlattenToolIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faLayerGroup} {...props} />
);

export default FlattenToolIcon;
